import './poster.scss';
import ImageGenerator from '../image-generator/image-generator';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import fallbackImage from '../../assets/images/poster-1-mini.png';


function Posters({ data }) {
	const [isMobile, setIsMobile] = useState(false);

	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerWidth <= 680);
		};

		handleResize(); // Run once on mount
		window.addEventListener('resize', handleResize);

		return () => window.removeEventListener('resize', handleResize);
	}, []);


	return (
		<div className={`poster-container style-${data.postersCount}`}>
			{data.items.map((item, index) => (
				<Link className="poster-item" to={`/t/poster/${item.id}`} key={index}>
					<div className="items">
						<ImageGenerator
							src={isMobile && data.postersCount === 1 ? fallbackImage : item?.image}
							alt={item?.title}
						/>
					</div>
				</Link>
			))}
		</div>
	);
}

export default Posters;
